export const PLUGIN_KEY = 'aks-insert-cta';

export enum AksInsertCtaButton {
  InsertCta = 'aks-insert-cta',
  EditCta = 'aks-edit-cta',
  DeleteCta = 'aks-delete-cta',
}